export function clearFormValidateOnLangChange (vm, refNames = []) {
  refNames.forEach((refName) => {
    const form = vm.$refs[refName]
    if (form && typeof form.clearValidate === 'function') {
      form.clearValidate()
    }
  })
}

/**
 * 按当前界面语言过滤功能页点击统计/下拉项。
 * 新记录带 lang（zh-CN / en-US）；旧记录无 lang 时用 pageName 启发式推断。
 */
export function matchesFunctionPageLang (item, pageLang) {
  if (!item || !item.pageName) return false
  if (item.lang) return item.lang === pageLang

  const hasChinese = /[\u4e00-\u9fff]/.test(item.pageName)
  if (pageLang === 'en-US') {
    // 英文界面：仅展示非中文页名
    return !hasChinese
  }
  if (pageLang === 'zh-CN') {
    return hasChinese
  }
  return true
}
